<ion-app>
	<app-custom-header *ngIf="router.url != '/'"></app-custom-header>
	<ion-content>
		<div class="ion-page" id="main-content">
			<ion-router-outlet></ion-router-outlet>
		</div>
	</ion-content>
</ion-app>